import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FeedbackService } from '@dash/randy/shared/observability/feedback.service';

@Component({
  selector: 'app-inline-load-error',
  templateUrl: './inline-load-error.component.html',
  styleUrls: ['./inline-load-error.component.scss'],
  standalone: false,
})
export class InlineLoadErrorComponent {
  private readonly feedbackService = inject(FeedbackService);

  @Input({ required: true }) message!: string;
  @Input() retryable = true;
  @Input() reportable = true;
  @Input() reportContext?: string;
  @Input() error?: unknown;
  @Output() readonly retry = new EventEmitter<void>();

  reportError(): void {
    this.feedbackService.open({
      diagnostics: this.reportContext ? { context: this.reportContext } : undefined,
      error: this.error,
      source: 'inline-load-error',
    });
  }
}
